// add every new feature here for the app to register the page route
import { lazy } from "react"

// pages
import {
  Dashboard,
  Vehicle,
  ProcessPapers,
  Delivery,
  Cart,
  Payments,
  Orders,
  DriversLicense,
  PriceEstimate,
  Faqs,
  Admin,
  Profile,
  Terms,
} from "../../packages/features"

const ChangePassword = lazy(() => import("../../app/auth/change-password"))

export const authPages = [
  {
    path: "change-password",
    Component: ChangePassword,
  },
  ...Dashboard,
  ...Vehicle,
  ...ProcessPapers,
  ...Delivery,
  ...Cart,
  ...Payments,
  ...Orders,
  ...DriversLicense,
  ...PriceEstimate,
  ...Faqs,
  ...Admin,
  ...Profile,
  ...Terms,
]

export default authPages
